import { createContext } from "react"

export const AuthContext = createContext({
  isAuthState: undefined,
  authenticate: (state) => {},
  logout: () => {}
})